import { Flex } from '@applyboard/crystal-ui';

import { GradeConversionDetailsHeading } from '../components/GradeConversionDetailsHeading';
import { GradeConversionInformation } from '../components/GradeConversionInformation';
import { GradeConversionLayoutProps } from './types';

export function MobileLayout(props: GradeConversionLayoutProps) {
  const { conversionTable, gradeSchema, gradePointMappings, educationLevels, countries } = props;

  return (
    <Flex p={4} gap={4} direction="column">
      <GradeConversionDetailsHeading />
      <GradeConversionInformation
        conversionTable={conversionTable}
        gradeSchema={gradeSchema}
        gradePointMappings={gradePointMappings}
        educationLevels={educationLevels}
        countries={countries}
      />
    </Flex>
  );
}
